<template>
  <a-modal :title="lang=='en'?'Modify Password':'修改密码'" v-model:visible="visible" @ok="toalter" @cancel="afterClose">
    <a-form :model="passwordState" :rules="passwordRules" ref="formref">
      <a-form-item :label="lang=='en'?'Original password':'原始密码'" name="password1">
        <a-input-password v-model:value.trim="passwordState.password1" :placeholder="lang=='en'?'Original password':'原始密码'"></a-input-password>
      </a-form-item>
      <a-form-item :label="lang=='en'?'New password':'新密码'" name="password2">
        <a-input-password v-model:value.trim="passwordState.password2" :placeholder="lang=='en'?'New password':'新密码'"></a-input-password>
      </a-form-item>
      <a-form-item  :label="lang=='en'?'Confirm password':'确认密码'" name="password3">
        <a-input-password v-model:value.trim="passwordState.password3" :placeholder="lang=='en'?'Confirm password':'确认密码'"></a-input-password>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script setup>

import { watch } from 'vue';
import { ref } from 'vue';
import { modifyPassword } from './homePageComponent/js';
import { reactive } from 'vue';
import { message } from 'ant-design-vue/lib/components';
const passwordState = reactive({
      password1: "",
      password2: "",
      password3: "",
    });
    const formref=ref()
const showProp = defineProps({
  modifyPasswordVisible:{type:Boolean,default:false}
})
const showEmit =defineEmits(['toModifyPasswordVisible'])
const visible=ref(false)
watch(()=>showProp.modifyPasswordVisible,(val)=>{
     if(val==true){
        if (formref.value && formref.value.clearValidate != undefined) {
            formref.value.clearValidate();
        }
        for (var i in passwordState) {
             passwordState[i] ="";
          }
     }
     visible.value=val
})
const lang =""
const passwordValidator = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(lang=='en'?"Please input password":"请输入密码"));
      } else {
        if (value.length < 6) {
          callback(new Error(lang=='en'?"The password can not be less than 6 digits":"密码至少为6个字符"));
        } else callback();
      }
};
const passwordValidator1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(lang=='en'?"Please input password":"请输入密码"));
      } else {
        if (value.length < 6) {
            callback(new Error(lang=='en'?"The password can not be less than 6 digits":"密码至少为6个字符"));
        } else if (value != passwordState.password2) {
          callback(new Error(lang=='en'?"The new password and the confirmation password do not match.":"新密码与确认密码不一致"));
        } else callback();
      }
    };
const passwordRules = ref({
      password1: [
        {
          required: true,
          min: 6,
          validator: passwordValidator,
          trigger: "blur",
        },
      ],
      password2: [
        {
          required: true,
          min: 6,
          validator: passwordValidator,
          trigger: "blur",
        },
      ],
      password3: [
        {
          required: true,
          min: 6,
          validator: passwordValidator1,
          trigger: "blur",
        },
      ],
    });
    const toalter = () => {
      formref.value.validate().then((valid) => {
        if(valid){
          modifyPassword({
          originPassword: passwordState.password1,
          newPassword: passwordState.password2,
        }).then((res) => {
          for (var i in passwordState) {
             passwordState[i] ="";
          }
          if (res.data == false) {

            message.error(lang=='en'?'Failed':'修改失败！')
          
          } else {

            message.success(lang=='en'?'Succeeded':res.msg)
             showEmit('toModifyPasswordVisible',false)
          }
        });
        }
      });
    };
    const afterClose=()=>{
   
      showEmit('toModifyPasswordVisible',false)
    }
</script>